/**
 * Configurações de colisão para todas as parcelas (0-281) e o castelo
 * 
 * Formato para cada parcela:
 * 'número da parcela': {
 *   offsetX: número, // Deslocamento horizontal da caixa de colisão
 *   offsetZ: número, // Deslocamento de profundidade da caixa de colisão
 *   scaleWidth: número, // Escala da largura da caixa de colisão
 *   scaleHeight: número, // Escala da altura da caixa de colisão
 *   scaleDepth: número // Escala da profundidade da caixa de colisão
 * }
 * 
 * Valores padrão:
 * - offsetX: -18
 * - offsetZ: -18
 * - scaleWidth: 1.0
 * - scaleHeight: 1.0
 * - scaleDepth: 1.0
 */

export interface ParcelCollisionConfig {
  offsetX: number;
  offsetZ: number;
  scaleWidth: number;
  scaleHeight: number;
  scaleDepth: number;
}

// Configuração padrão para todas as parcelas
const defaultConfig: ParcelCollisionConfig = {
  offsetX: -18,
  offsetZ: -18,
  scaleWidth: 1.0,
  scaleHeight: 1.0,
  scaleDepth: 1.0
};

// Configurações específicas para parcelas individuais
const parcelCollisionConfigs: Record<string, ParcelCollisionConfig> = {
  // Configuração global padrão
  'default': defaultConfig,

  // Configurações específicas para parcelas individuais
  // Parcel 0
  '0': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 1
  '1': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 2
  '2': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 3
  '3': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 4
  '4': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 5
  '5': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 6
  '6': { offsetX: -25, offsetZ: -25, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 7
  '7': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 8
  '8': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 9
  '9': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 10
  '10': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 11
  '11': { offsetX: -29, offsetZ: -29, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 12
  '12': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 13
  '13': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 14
  '14': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 15
  '15': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 16
  '16': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 17
  '17': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 18
  '18': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 19
  '19': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 20
  '20': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Continuar para as parcelas 21-69...
    // Parcel 20
  
  '21': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },

  '22': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '23': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '24': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '25': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '26': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '27': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '28': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '29': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '30': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '31': { offsetX: -25, offsetZ: -25, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  '32': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '33': { offsetX: -25, offsetZ: -25, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '34': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '35': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '36': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '37': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '38': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '39': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '40': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '41': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '42': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '43': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '44': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '45': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '46': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '47': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '48': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '49': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '50': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '51': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '52': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '53': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '54': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '55': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '56': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '57': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '58': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '59': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '60': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '61': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '62': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '63': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '64': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '65': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '66': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '67': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '68': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '69': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '70': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '71': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '72': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '73': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '74': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '75': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '76': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '77': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '78': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '79': { offsetX: -22, offsetZ: -22, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '80': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '81': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '82': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '83': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '84': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '85': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '86': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '87': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '88': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '89': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '90': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '91': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '92': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '93': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '94': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '95': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '96': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '97': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '98': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '99': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '100': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '101': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '102': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '103': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '104': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '105': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '106': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '107': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '108': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '109': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '110': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },  
  '111': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  '112': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '113': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '114': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '115': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '116': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '117': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '118': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '119': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '120': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '121': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '122': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '123': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '124': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '125': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '126': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '127': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '128': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '129': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '130': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '131': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '132': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '133': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '134': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '135': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '136': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '137': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '138': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '139': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '140': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '141': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '142': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '143': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '144': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '145': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '146': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '147': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '148': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '149': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '150': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '151': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '152': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '153': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '154': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '155': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '156': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '157': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '158': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '159': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '160': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '161': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '162': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '163': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '164': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '165': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '166': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '167': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '168': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '169': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '170': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '171': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '172': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '173': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '174': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '175': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '176': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '177': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '178': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '179': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '180': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '181': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '182': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '183': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '184': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '185': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '186': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '187': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '188': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '189': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '190': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '191': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '192': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '193': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '194': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '195': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '196': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '197': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '198': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '199': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '200': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '201': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '202': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '203': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '204': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '205': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '206': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '207': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '208': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '209': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '210': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '211': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '212': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '213': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '214': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '215': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '216': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '217': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '218': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '219': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '220': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '221': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '222': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '223': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '224': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '225': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '226': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '227': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '228': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '229': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '230': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '231': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '232': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '233': { offsetX: -18, offsetZ: -18, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '234': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '235': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '236': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '237': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '238': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '239': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '240': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '241': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '242': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '243': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '244': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '245': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '246': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '247': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '248': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '249': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '250': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '251': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '252': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '253': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '254': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '255': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '256': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '257': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '258': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '259': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '260': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '261': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '262': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '263': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '264': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '265': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '266': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '267': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '268': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '269': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.8, scaleDepth: 1.0 }, 
  '270': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '271': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '272': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '273': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '274': { offsetX: -3.5, offsetZ: -3.5, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '275': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '276': { offsetX: -14, offsetZ: -14, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '277': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '278': { offsetX: -7, offsetZ: -7, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 }, 
  '279': { offsetX: -29, offsetZ: -29, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 280
  '280': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
  
  // Parcel 281
  '281': { offsetX: -11, offsetZ: -11, scaleWidth: 1.0, scaleHeight: 0.5, scaleDepth: 1.0 },
};

// Função para gerar configurações para todas as parcelas de 0 a 281
export function generateAllParcelConfigs(): Record<string, ParcelCollisionConfig> {
  const configs = { ...parcelCollisionConfigs };
  
  // Preencher configurações para todas as parcelas que não foram definidas explicitamente
  for (let i = 0; i <= 281; i++) {
    if (!configs[i.toString()]) {
      configs[i.toString()] = { ...defaultConfig };
    }
  }
  
  return configs;
}

// Exportar as configurações
export default parcelCollisionConfigs;
